import { file } from "jszip";
import store from "../../../store";
import ApiHelper from "../../helpers/ApiHelper";
import GeneralVariables from "../../utils/GeneralVariables";
import BaseService from "../BaseService";

class RfpService extends BaseService {
    static url = "rfps";

    static apis = {
        that: this,
        getQuotations: function(id) {
            return "rfps/" + id + "/quotations";
        },
        filter: { method: "get", path: this.url + "/filter" },
        filterBrands:{method:'get', path: this.url + "/filterBrands"},
        filterCategories:{method:'get', path: this.url + "/filterCategories"},
        filterMaxPrice:{method:'get', path: this.url + "/filterMaxPrice"},
        matchKits:{method:'get', path: this.url + '/matching-kits'},
        filterMinPrice:{method:'get', path: this.url + "/filterMinPrice"},
        
        views: function(id) {
            return this.that.url + "/" + id + "/views";
        },
        guestCreate: function() {
            return "rfps/guest";
        },
        duplicateRfps: { method: "post", path: this.url + "/duplicateRfps" },
        deleteRfps: { method: "delete", path: this.url + "/deleterfps" },
        latestRFP: { method: "get", path: this.url + "/latestRFP" },
        changeStatusOfExpired: { method: "put", path: this.url + "/change_status_of_expired" },
        editRfpStatus: {method:"post", path: this.url + "/change-rfp-status"},
        creation_chat:{method:'post', path: this.url + "/creation_chat"},
        export: {method: 'get', path: this.url + "/export"},

    };

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("rfps");
    }

    getMatchingKits(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: RfpService.apis.matchKits.path+'/'+id,
                    method: RfpService.apis.matchKits.method,
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }


    exportAllRfps(data){
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: RfpService.apis.export.path,
                    method: RfpService.apis.export.method,
                    authorization: true,
                    responseType: 'blob',
                    params: data
                })
                .then((response) => {
                    const now = new Date();
                    const day = String(now.getDate()).padStart(2, '0');
                    const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are 0-based
                    const year = now.getFullYear();
                    const fileName = `Topotrade_Requests_${day}-${month}-${year}.xlsx`;
                    const url = URL.createObjectURL(new Blob([response.data]))
                    const link = document.createElement('a')
                    link.href = url
                    link.setAttribute(
                      'download',
                      fileName
                    )
                    document.body.appendChild(link)
                    link.click()
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    guestCreate(data, params) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: RfpService.apis.guestCreate(),
                    data: data,
                    method: "POST",
                    showLoader: true,
                    authorization: false,
                    message: params.message,
                })
                .then((resp) => {
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    latestRFP(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: RfpService.apis.latestRFP.path,
                    data: data,
                    method: RfpService.apis.latestRFP.method,
                    showLoader: true,
                    authorization: false,
                    
                })
                .then((resp) => {
                    resolve(resp);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }

    filter(data, authorize = false) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: RfpService.apis.filter.path,
                    method: RfpService.apis.filter.method,
                    authorization: authorize,
                    params: data,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }


    filterBrands(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: RfpService.apis.filterBrands.path,
                    method: RfpService.apis.filterBrands.method,
                    authorization: false,
                    showLoader: false,
                    params: data,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    filterCategories(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: RfpService.apis.filterCategories.path,
                    method: RfpService.apis.filterCategories.method,
                    authorization: false,
                    showLoader: false,
                    params: data,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }


    filterMinPrice(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: RfpService.apis.filterMinPrice.path,
                    method: RfpService.apis.filterMinPrice.method,
                    authorization: false,
                    showLoader: false,
                    params: data,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    filterMaxPrice(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: RfpService.apis.filterMaxPrice.path,
                    method: RfpService.apis.filterMaxPrice.method,
                    authorization: false,
                    showLoader: false,
                    params: data,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    views(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: RfpService.apis.views(id),
                    method: "POST",
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    reject(err);
                });
        });
    }
    deleterfps(ids) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: RfpService.apis.deleteRfps.path,
                    method: RfpService.apis.deleteRfps.method,
                    data: { ids: ids },
                    showLoader: true,
                    authorization: true,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }
    duplicaterfps(ids) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: RfpService.apis.duplicateRfps.path,
                    method: RfpService.apis.duplicateRfps.method,
                    data: { ids: ids },
                    showLoader: true,
                    authorization: true,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }
    getQuotations(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: RfpService.apis.getQuotations(id),
                    method: "get",
                    showLoader: true,
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }

    getQuotations1(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({ url: RfpService.apis.getQuotations(id), method: "get", showLoader: true, authorization: true, }).then((response) => {
                resolve(response)
            }).catch(error => {
                reject(error.response)
            })
        });
    }

    changeStatusOfExpired()
    {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: RfpService.apis.changeStatusOfExpired.path,
                    method: RfpService.apis.changeStatusOfExpired.method,
                    showLoader: true,
                    authorization: true,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }

    editRfpStatus(data) 
    {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: RfpService.apis.editRfpStatus.path,
                    method: RfpService.apis.editRfpStatus.method,
                    authorization: true,
                    data: data,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    createFromChat(data) 
    {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: RfpService.apis.creation_chat.path,
                    method: RfpService.apis.creation_chat.method,
                    authorization: true,
                    showLoader:false,
                    data: data,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    }

    async createFromChatStream(data) 
    {
        let url = GeneralVariables.BACKEND + 'api/v1.0/' + RfpService.apis.creation_chat.path
                let token = store.getters.token
                return fetch(url, {
                        method: RfpService.apis.creation_chat.method, // *GET, POST, PUT, DELETE, etc.
                        mode: "cors", // no-cors, *cors, same-origin
                        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                        credentials: "same-origin", // include, *same-origin, omit
                        headers: {
                        "Content-Type": "application/json",
                        "Authorization":"Bearer "+ token
                        },
                        redirect: "follow", // manual, *follow, error
                        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                        body: JSON.stringify(data), // body data type must match "Content-Type" header
                        signal: data.signal
                    }
                );
                
    }

}

export default RfpService;